const popup = () => {
  const closePopups = document.querySelectorAll('.js-close');
  if (closePopups.length) {
    closePopups.forEach(closePopup => {
      closePopup.addEventListener('click', () => {
        document.querySelector('.js-popup').classList.remove('is-active');
        document.querySelector('.js-popup-video iframe').src = '';
        document.querySelector('.js-fbcomment .c-post__comments').remove();
      });
    });
  }
  const videoPopups = document.querySelectorAll('.js-video');
  if (videoPopups.length) {
    videoPopups.forEach(videoPopup => {
      if (videoPopup) {
        function handleClick() {
          const title = this.dataset.videoTitle;
          const desc = this.dataset.videoDesc;
          const comment_url = this.dataset.videoComment;
          const comment_status = parseInt(this.dataset.commentStatus);
          let src = ``;
          if (isNaN(this.dataset.videoSrc)) {
             src = `https://www.youtube.com/embed/${this.dataset.videoSrc}?feature=oembed&rel=0`;
          } else {
            src = `https://player.vimeo.com/video/${
              this.dataset.videoSrc
            }?autoplay=1&loop=1&autopause=0&api=1&controls=1`;
          }

          document.querySelector('.js-popup-video iframe').src = src;
          document.querySelector('.js-popup-title').innerHTML = title;
          document.querySelector('.js-popup-description').innerHTML = desc;
          document.querySelector('.js-popup').classList.add('is-active');
          if(comment_status){
            document.querySelector('.js-fbcomment').innerHTML = '<div class="c-post__comments"><div class="fb-comments" data-colorscheme="dark" data-href="' + comment_url + '" data-numposts="5" data-width="100%"></div></div>';
            FB.XFBML.parse();
          }
          else{
            document.querySelector('.js-fbcomment').innerHTML = '<div class="c-post__comments"></div>';
          }
        }
        videoPopup.addEventListener('click', handleClick);
      }
    });
  }
};
export default popup;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/popup.js